// @generated
import { PapiDeviation } from '@wix/da-papi-types';

export const literatureDeviations: PapiDeviation[] = [
  {
    deviationId: 656192737,
    typeId: 1,
    url: 'https://www.deviantart.com/epicoflilith/art/Lilith-656192737',
    title: 'Lilith',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2017-01-08T07:42:05-0800',
    isTextEditable: false,
    legacyTextEditUrl: 'https://www.deviantart.com/deviation/edit/656192737',
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 41278525,
      useridUuid: '356cf78d-2a67-440a-a2d8-4c00ad2a3da4',
      username: 'EpicOfLilith',
      usericon: 'https://a.deviantart.net/avatars-big/e/p/epicoflilith.jpg?7',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 25,
      favourites: 1745,
    },
    media: {
      types: [
        {
          t: 'preview',
          r: -2,
          s: 'https://img00.deviantart.net/bb46/a/shared/poetry.jpg',
          h: 220,
          w: 500,
        },
      ],
    },
    textContent: {
      excerpt:
        'I am the silken ruby\nEmerald are my eyes\nMy beauty goes unrivalled\nMy soul the essence of lies\nLet the fear of me surround you\nI shall feed upon your cries\nConsume your very being\nSo my blackened soul might rise\nI am the twisted thorns which bind you\nThe hidden darkness down below\nResist not this malevolent allure\nCome, follow me to shadow?',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 5833590,
    typeId: 1,
    url: 'https://www.deviantart.com/so0olovely/art/heart-broken-5833590',
    title: 'heart broken',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2004-03-14T05:13:38-0800',
    isTextEditable: false,
    legacyTextEditUrl: 'https://www.deviantart.com/deviation/edit/5833590',
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 656220,
      useridUuid: 'b67f7ea2-456b-409d-b64e-febb9f3148ff',
      username: 'so0olovely',
      usericon: 'https://a.deviantart.net/avatars-big/s/o/so0olovely.gif',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 690,
      favourites: 3503,
    },
    media: {
      types: [
        {
          t: 'preview',
          r: -2,
          s: 'https://img00.deviantart.net/bb46/a/shared/poetry.jpg',
          h: 220,
          w: 500,
        },
      ],
    },
    textContent: {
      excerpt:
        "In my dreams\nIt was me in your arms\nMy lips on yours\nThere was only us\nAnd the clouds\nAnd the stars\nIt was the world and us\nIt was us against the world\nBut in your arms I could take it\nAnything the world dished out\nAnd with your kisses I was strong again\nIn my dreams it was me in your arms\nMy lips on yours\nBut in reality\nIt's always been her",
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 43850242,
    typeId: 1,
    url: 'https://www.deviantart.com/fallenpoeticlover/art/Love-it-43850242',
    title: 'Love it',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2006-11-29T05:39:36-0800',
    isTextEditable: false,
    legacyTextEditUrl: 'https://www.deviantart.com/deviation/edit/43850242',
    isShareable: false,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 1744923,
      useridUuid: '65e433ac-3311-4543-b450-5abbcc409500',
      username: 'fallenpoeticlover',
      usericon: 'https://a.deviantart.net/avatars-big/f/a/fallenpoeticlover.jpg?4',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 2348,
      favourites: 8621,
    },
    media: {
      types: [
        {
          t: 'preview',
          r: -2,
          s: 'https://img00.deviantart.net/bb46/a/shared/poetry.jpg',
          h: 220,
          w: 500,
        },
      ],
    },
    textContent: {
      excerpt:
        "I feel your hands in my hair.\nI feel your breath on my neck.\nI feel your body pressed so close to mine.\nI feel your lips on my throat.\nI feel your hands move to my back and your lips work their way up to mine.\nI feel you and I love it.\n\nI hear you say you love me.\nI hear you whisper my name.\nI hear you tell me I'm the only one for you.\nI hear your breath in my ear.\nI hear your soft snores as I fall asleep.\nI hear you and I love it.\n\nI see you as I run into your arms.\nI see your face break through my world of darkness.\nI see you fight away my fears.\nI see you wipe away my tears.\nI see you're in love with me.\nI see you and I love",
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 99306193,
    typeId: 1,
    url: 'https://www.deviantart.com/spyed/art/dArama-ISSUE-ONE-Love-99306193',
    title: 'dArama - ISSUE ONE - Love.',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2008-09-29T01:37:45-0700',
    isTextEditable: false,
    legacyTextEditUrl: 'https://www.deviantart.com/deviation/edit/99306193',
    isShareable: false,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 29,
      useridUuid: 'f2433f81-3957-4f57-9715-1a963ab3b0bb',
      username: 'spyed',
      usericon: 'https://a.deviantart.net/avatars-big/s/p/spyed.gif',
      type: 'admin',
      isNewDeviant: false,
    },
    stats: {
      comments: 632,
      favourites: 2948,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/f2433f81-3957-4f57-9715-1a963ab3b0bb/d1n4h5d-1215ee6a-c3e2-4874-8145-fb9a8d5a2270.gif',
      types: [
        {
          t: 'preview',
          r: -1,
          h: 97,
          w: 43,
          f: 2330,
        },
        {
          t: 'social_preview',
          r: -1,
          h: 97,
          w: 43,
        },
      ],
    },
    textContent: {
      excerpt:
        "The dynamic between core staff, volunteer staff, and the community can at times be pure quality dArama.\n\nIt's worth noting that for years I've worked pretty hard to remain neutral on community politics. Today, I'm going to shatter that concept.\n\nNeedless to say, I am extremely politically aware of the inner workings of the deviantART community. I read *a lot* of journals, comments, forums, chat rooms. I have fake accounts. I spy.\n\nBut I don't spend my time talking politics, instead I focus internally at deviantART designing technologies and implementing understandings with core staff to address the issues I see pop up.\n\nIt's time to take a mo",
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 313890699,
    typeId: 1,
    url: 'https://www.deviantart.com/plaid-rose/art/Gay-313890699',
    title: 'Gay',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2012-07-10T16:18:28-0700',
    isTextEditable: false,
    legacyTextEditUrl: 'https://www.deviantart.com/deviation/edit/313890699',
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 8343393,
      useridUuid: 'bf4646a0-3d58-490f-a413-bc80459c5dce',
      username: 'Plaid-Rose',
      usericon: 'https://a.deviantart.net/avatars-big/p/l/plaid-rose.jpg?11',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 7624,
      favourites: 9845,
    },
    media: {
      types: [
        {
          t: 'preview',
          r: -2,
          s: 'https://img00.deviantart.net/bb46/a/shared/poetry.jpg',
          h: 220,
          w: 500,
        },
      ],
    },
    textContent: {
      excerpt:
        "I am gay.\nI'm not a disease, I'm not a problem\nI'm not an affliction\nI don't need treatment.\nI don't need help\nI'm not sick\nI'm not confused\nI'm not a sin.\n\nI am gay.\nI'm your daughter\nYour sister\nYour friend\nYour co worker\nYour classmate\nYour acquaintance\nA complete stranger\n\nI am gay.\nI need love, just like you\nI need smiles\nI need support\nI need a hug\nI need a friend\nI need a family\nI need acceptance\nI need understanding\nI need you\n\nI am gay.\nI know what love is\nI know what pain is\nI know what hate is\nI know what life is\n\nI am gay.\nAnd I need you to love me\nThe same way you loved me before you knew\n\nI am gay.\n",
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 474092747,
    typeId: 1,
    url: 'https://www.deviantart.com/sparkythewingedcat/art/Warrior-Cats-Name-Dictionary-474092747',
    title: 'Warrior Cats Name Dictionary',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2014-08-11T10:00:44-0700',
    isTextEditable: false,
    legacyTextEditUrl: 'https://www.deviantart.com/deviation/edit/474092747',
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 29658644,
      useridUuid: '78107bf4-a258-45d3-9811-64d203ee6735',
      username: 'SparkytheWingedCat',
      usericon: 'https://a.deviantart.net/avatars-big/s/p/sparkythewingedcat.gif?2',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 4464,
      favourites: 2717,
    },
    media: {
      types: [
        {
          t: 'preview',
          r: -2,
          s: 'https://img00.deviantart.net/bb46/a/shared/poetry.jpg',
          h: 220,
          w: 500,
        },
      ],
    },
    textContent: {
      excerpt:
        "Hello and welcome to the warrior cats name dictionary! Here you can look at all the prefixes and suffixes and what they mean, helping you create the perfect name for an OC or character. Let's get started!\n\nPREFIXES\n &nbsp; &nbsp;Acorn - Naive; outgoing; curious; appearance of an acorn.\n &nbsp; &nbsp;Adder - Aggressive; loyal; appearance of an adder.\n &nbsp; &nbsp;Alder - Reserved; cautious; wise; appearance of an alder tree; see Bark; see Timber.\n &nbsp; &nbsp;Amber - Pushy; strict; amber-furred.\n &nbsp; &nbsp;Ant - Cooperative; cocky; appearance of an ant.\n &nbsp; &nbsp;Apple - Sweet; friendly; multi-skilled; appearance of an apple.\n &nbsp; &nbsp;Arch - Strict; aggressive; observant; arched body part/marking.\n",
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 420672258,
    typeId: 1,
    url: 'https://www.deviantart.com/zephyros22/art/RQ-Rivaille-x-Reader-Seduce-me-in-French-420672258',
    title: 'RQ: Rivaille x Reader: Seduce me in French',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2013-12-19T18:00:44-0800',
    isTextEditable: false,
    legacyTextEditUrl: 'https://www.deviantart.com/deviation/edit/420672258',
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 21302243,
      useridUuid: '280a1445-ac89-416a-85d2-97bae7828375',
      username: 'Zephyros22',
      usericon: 'https://a.deviantart.net/avatars-big/z/e/zephyros22.jpg?14',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 783,
      favourites: 3406,
    },
    media: {
      types: [
        {
          t: 'preview',
          r: -2,
          s: 'https://img00.deviantart.net/bb46/a/shared/poetry.jpg',
          h: 220,
          w: 500,
        },
      ],
    },
    textContent: {
      excerpt:
        '"Corporal knows French?"\n\nYou stared at Connie incredulously, you jaw slightly agape.\n\nConnie, satisfied with your response, leaned back in his chair, crossing his arms behind his head. A shit-eating grin spread across his face, and he responded with a haughty tone: "Eyup. I heard him the other day, he was cursing in french at something that had gotten on his boot."\n\nBeside you, Reiner chuckled, the sound deep and low and reverberating up your spine. "Yeah right, Connie, you little weasel. How do we know you aren\'t lying?"\n\nConnie sat forward, his face enraged. "I\'m not lying!" he exclaimed. "It\'s true!!"\n\nJean looked less than convinced. "Re',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 90203444,
    typeId: 1,
    url: 'https://www.deviantart.com/nikatil/art/10-Ways-to-Annoy-Edward-Cullen-90203444',
    title: '10 Ways to Annoy Edward Cullen',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2008-06-29T22:26:09-0700',
    isTextEditable: false,
    legacyTextEditUrl: 'https://www.deviantart.com/deviation/edit/90203444',
    isShareable: false,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 4434865,
      useridUuid: 'f1d43acb-bba9-4992-9af7-97fd6c3dfa62',
      username: 'nikatil',
      usericon: 'https://a.deviantart.net/avatars-big/n/i/nikatil.jpg?4',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 1148,
      favourites: 5015,
    },
    media: {
      types: [
        {
          t: 'preview',
          r: -2,
          s: 'https://img00.deviantart.net/bb46/a/shared/poetry.jpg',
          h: 220,
          w: 500,
        },
      ],
    },
    textContent: {
      excerpt:
        '10 Ways to Annoy Edward Cullen\n\n10. Sing &#147;Discovery Channel&#148; by the Bloodhound Gang in your head whenever he is near.\n\n9. Hotwire his Volvo and take it on a joyride.\n\n8. Tell him the relationship he is having with Bella is practically paedophilia and he could be sent to jail for it.\n\n7. Ask how Tanya is.\n\n6. End every argument with &#147;Bite me, Edward.&#148;\n\n5. Call him Romeo both behind his back and to his face.\n\n4. Whenever he complains or argues, reply with &#147;What are you gonna do Edward? Go to Italy?&#148;\n\n3. Tell him his hair isn&#146;t bronze, it&#146;s ginger, and he should stop denying himself &#150; he&#146;s a rang',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 36823983,
    typeId: 1,
    url: 'https://www.deviantart.com/thirdpotato/art/Character-Profile-Form-36823983',
    title: 'Character Profile Form',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2006-07-24T09:58:34-0700',
    isTextEditable: false,
    legacyTextEditUrl: 'https://www.deviantart.com/deviation/edit/36823983',
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 405317,
      useridUuid: 'd698d3d5-6f63-4886-ab4a-93ab72d97fed',
      username: 'ThirdPotato',
      usericon: 'https://a.deviantart.net/avatars-big/t/h/thirdpotato.gif?9',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 2020,
      favourites: 11330,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/d698d3d5-6f63-4886-ab4a-93ab72d97fed/dlx9kf-3e4fa1ea-632b-4b81-9385-e3c69dbb75f6.png',
      prettyName: 'character_profile_form_by_thirdpotato_dlx9kf',
      types: [
        {
          t: 'preview',
          r: -1,
          c: 'v1/fill/w_217,h_217,q_80,strp/<prettyName>-fullview.jpg',
          h: 217,
          w: 217,
          f: 32610,
        },
        {
          t: 'social_preview',
          r: -1,
          c: 'v1/fill/w_217,h_217,q_80,strp/<prettyName>-fullview.jpg',
          h: 217,
          w: 217,
        },
      ],
    },
    textContent: {
      excerpt:
        'Basic Statistics\n\nName: \nNickname: \nMeaning of name:\nOrigin of name:\nAge: \nSex: \nBlood type: \nNationality: \nEthnicity: \nRace: \nSexual Orientation: \nCurrent status: \nPolitical Party: \nPolice/Criminal/Legal record: \nSocioeconomic level as a child: \nSocioeconomic level as an adult: \nBirth date: \nBirth place: \nCurrent residence: \nOccupation: \nTitle/Rank: \nHobbies/Pastimes: \nTalents/Skills/Powers:\n\nPast History\n\nHometown: \nFirst Memory: \nMost important childhood event that still affects him/her: \nWhy/How? \nOther memories/events that still affects him/her and why/how: \nPast failures s/he would be embarrassed to have people know about and why: \nBigg',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 460031650,
    typeId: 1,
    url: 'https://www.deviantart.com/theboson/art/Blank-Character-Sheet-2-1-8-390-Questions-460031650',
    title: 'Blank Character Sheet 2.1.8 (390+ Questions!)',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2014-06-10T23:14:46-0700',
    isTextEditable: false,
    legacyTextEditUrl: 'https://www.deviantart.com/deviation/edit/460031650',
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 31306657,
      useridUuid: 'c0d192dc-d452-4591-b67f-be1d45fd2d62',
      username: 'TheBoson',
      usericon: 'https://a.deviantart.net/avatars-big/t/h/theboson.png?7',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 290,
      favourites: 4346,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/c0d192dc-d452-4591-b67f-be1d45fd2d62/d7lw2oy-0051b779-99a2-4024-94f5-d322a6d5dbd1.png',
      prettyName: 'blank_character_sheet_2_1_8__390__questions___by_theboson_d7lw2oy',
      types: [
        {
          t: 'preview',
          r: -1,
          c: 'v1/fill/w_894,h_894,q_70,strp/<prettyName>-pre.jpg',
          h: 894,
          w: 894,
          f: 1845230,
        },
        {
          t: 'social_preview',
          r: -1,
          c: 'v1/fill/w_894,h_894,q_70,strp/<prettyName>-pre.jpg',
          h: 894,
          w: 894,
        },
      ],
    },
    textContent: {
      excerpt:
        'The accompanying Google Doc has a nice guide for each attribute!\n\n"A quote from or about your character."\n &nbsp; &nbsp; &nbsp; - Book, Chapter\n\n &nbsp; &nbsp; General Information\nName: \nPronunciation: \nName Meaning: \nName Origin: \nOther Names: \nGender: \nTitles:\n\nBirth Name: \nBirth Date: \nBirth Length: \nBirth Weight: \nBirth Place: \nManner of Birth: \nFirst Word(s):\n\nDeath Date: \nDeath Place: \nManner of Death: \nResting Place: \nLast Words:\n\nDominant Hand: \nAstrological Sign: \nCatchphrase: \nAutograph: \nHandwriting: \nID Number/SSN: \nLicense Plate Number:\n\n &nbsp; &nbsp; Appearance\nPicture:\n\nHeight: \nWeight: \nSpecies: \nRace: \nBlood Type: \nSymbol:\n\nSkin Color: \nBirthmarks: \nExtra Ana',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 167182524,
    typeId: 1,
    url: 'https://www.deviantart.com/character-resource/art/Big-Ass-Character-Sheet-Updating-167182524',
    title: 'Big-Ass Character Sheet (Updating)',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2010-06-10T14:17:08-0700',
    isTextEditable: false,
    legacyTextEditUrl: 'https://www.deviantart.com/deviation/edit/167182524',
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 14041711,
      useridUuid: '28e87ba7-91f0-4c9e-b796-21caef76e63c',
      username: 'Character-Resource',
      usericon: 'https://a.deviantart.net/avatars-big/default.gif',
      usericonDefault: true,
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 815,
      favourites: 6293,
    },
    media: {
      baseUri:
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/28e87ba7-91f0-4c9e-b796-21caef76e63c/d2rjav0-629bbdfe-fe71-4ca0-ab53-9036a961f585.png',
      prettyName: 'big_ass_character_sheet__updating__by_character_resource_d2rjav0',
      types: [
        {
          t: 'preview',
          r: -1,
          c: 'v1/fill/w_109,h_106,q_80,strp/<prettyName>-fullview.jpg',
          h: 106,
          w: 109,
          f: 1843,
        },
        {
          t: 'social_preview',
          r: -1,
          c: 'v1/fill/w_109,h_106,q_80,strp/<prettyName>-fullview.jpg',
          h: 106,
          w: 109,
        },
      ],
    },
    textContent: {
      excerpt:
        "Verse: (The universe your character belongs to. Can be original or fanfiction. [Ex: Original : The name of your book, movie, game or whatever. Fanfiction: Pokemon, Star Trek, Naruto, ect.)\nDate: (The date this sheet was completed.)\n\nFull Name: (Self explanatory)\nPronunciation: (Self explanatory)\nNickname/Alias: (Does your character have a pet name, fake identity, or any other thing they like to go by? Put it here.)\nMeaning: ([Ex: Emily means \"admiring\" and William means \"protector\"] If you aren't sure your character's name has a meaning look it up, I'm sure you'll find something. If it's a fantasy name you made yourself, give it a meaning.)\nO",
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
  {
    deviationId: 27628190,
    typeId: 1,
    url: 'https://www.deviantart.com/brokenxbeauty/art/Is-It-Love-27628190',
    title: 'Is It Love?',
    isJournal: false,
    isPurchasable: false,
    publishedTime: '2006-01-13T07:07:03-0800',
    isTextEditable: false,
    legacyTextEditUrl: 'https://www.deviantart.com/deviation/edit/27628190',
    isShareable: true,
    isCommentable: true,
    isFavourited: true,
    isDeleted: false,
    isMature: false,
    isDownloadable: false,
    isAntisocial: false,
    isBlocked: false,
    isPublished: true,
    blockReasons: [],
    author: {
      userId: 2210061,
      useridUuid: '3f062c1f-2ed0-4c8d-8e7c-6145dbc07f25',
      username: 'brokenxbeauty',
      usericon: 'https://a.deviantart.net/avatars-big/b/r/brokenxbeauty.jpg?7',
      type: 'regular',
      isNewDeviant: false,
    },
    stats: {
      comments: 3981,
      favourites: 18137,
    },
    media: {
      types: [
        {
          t: 'preview',
          r: -2,
          s: 'https://img00.deviantart.net/bb46/a/shared/poetry.jpg',
          h: 220,
          w: 500,
        },
      ],
    },
    textContent: {
      excerpt:
        'If I hugged you,\nwould you never let go?\n\nIf I kissed you,\nwould you cherish that moment?\n\nIf I reached for your hand,\nwould you take mine gently?\n\nIf I needed a shoulder,\nwould you let me cry on yours?\n\nIf I needed to talk,\nwould you really listen?\n\nIf I needed to scream,\nwould you do it with me?\n\nIf I needed to go,\nwould you come with me?\n\nIf I fell for you,\nwould you catch me?\nor just let me hit the pavement?',
      html: {
        type: 'writer',
        features: '',
      },
    },
  },
];
